<template>
    <div class="info-help">
        <div class="infobody-help">
            <div class="white-header">
                <div class="tenforty-wrap">
                    <router-link :to="$homeLink" class="c-back__box">
                        <span class="c-back__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14px">
                                <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path>
                            </svg>
                        </span>
                        <div>Return to info.my.vermont.gov</div>
                    </router-link>
                    <h1>Welcome to the Agency of Administration!</h1>
                    <div class="sub-headings">
                        <p><b>How can we help you?</b></p>
                        <div class="image-row">
                            <AOA_VTBUYS_Logo class="help-icon" />
                        </div>
                        <p class="heading-instruction">Please check the common problems and solutions for access to VTBuys before contacting customer support.</p>
                    </div>
                </div>
            </div>
            <div class="tenforty-wrap">
                                <HelpMfaBlock :envLinks="envLinks" appsRequiring="the CDDIS Parent or Provider Portal application"
                    mfaSupportText="For CDDIS MFA support, please call 1-800-649-2642 Option 9 to request a reset.">
                </HelpMfaBlock>
                <HelpGeneral :envLinks="envLinks"></HelpGeneral>
                <div class="noteAlt">
                    <i><font-awesome-icon icon="info-circle" /></i>
                    <div class="noteText">
                        <p>If you do not find an answer here, please submit a helpdesk request.</p>
                        <p>
                            Send your requests to
                            <a class="email-link" href="mailto:VTBuysCustomerSupport@vermont.gov?subject=Assistance with VTBuys login">VTBuysCustomerSupport@vermont.gov</a>
                            from your email account that you use or are planning to use to log into the application. Or call <a href="tel:+18028286446">802-828-6446</a> for assistance.
                        </p>
                        <p>Please be complete as possible in explaining your issue, and please include your contact information and availability. A representative should typically be able to respond within 48 hours or less to most requests.</p>
                        <p><u>
                            Please do not include any personal or identifying information (like Date of Birth or SSN) in your email.</u>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelpGeneral from './HelpGeneral'
import AOA_VTBUYS_Logo from '../../assets/AOA_VT_BUYS.vue'
import HelpMfaBlock from './HelpMFABlock'


export default {
    name: 'help-benefits',
    props: ['envLinks'],
    components: { HelpGeneral, AOA_VTBUYS_Logo, HelpMfaBlock },
    data() {
        return {
            appLink: this.envLinks.anrDecLoansGrants
        }
    }
}
</script>

<style scoped>
@import './help.css';
</style>
